export default {
  main: {
    site_id: 18774663,
    title: "Terminal PRO",
    enableWorldCup: true,
    showBetBuilderSection: true,
    terminalId: 41805,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    timeFormat: "HH:mm",
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    websitePasswordHash: "afdc0de55af006327794844d00cee66a2a36ca1592554974fd8c7177b82ff931",
    logoSize: "42x42",
    termsAndConditions: false,
    useCurrencySymbol: true,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    resultPageVirtualsId: [150, 197, 209, 118, 54, 55, 31, 184, 181],
    rfidPinCode: false,
    enableSportListScroll: false,
    showTicketAfterPay: 10000,
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    isWithdrawal: true,
    enableClientDepositMode: false,
    enableCopyBet: true,
    availableLanguages: {
      "@replace": true,
      fra: {
        short: "FR",
        name: "Fra",
        order: 1,
      },
      eng: {
        short: "EN",
        name: "Eng",
        order: 2,
      },
    },
  },
  env: {
    lang: "fra",
  },
  cashoutMethods: [
    { type: 'printTicket' },
  ],
  currencySymbol: {
    HTG: 'HTG ',
  },
  betslip: {
    "@replace": true,
    enableBookingBet: true,
    enableExpressBonus: true,
    enableBankerBet: true,
    enableCounterOffer: true,
    enableExpressCounterOffer: true,
    enableHotKeys: true,
    bookingBetBalanceMaxLimit: 9999999,
  },
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  routes: [
    {
      url: 'worldcup',
      name: 'FIFA World Cup',
      enabled: true,
      disableInHeader: true,
    },
    {
      url: 'betting/live',
      name: 'Live',
      enabled: true,
      icon: 'circle',
    },
    {
      url: 'betting/prematch',
      name: 'Sports',
      enabled: true,
      type: 'sportsBook',
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/virtuals',
          type: 'virtuals',
          name: 'Virtuals',
          enabled: true,
          icon: 'casino-categories-VirtualBetting',
          children: [
            {
              name: 'Games',
              url: 'betting/prematch/virtuals',
              icon: '',
            },
            {
              name: 'Results',
              url: 'betting/virtual-results',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/racings',
          name: 'Racing',
          enabled: true,
          icon: 'racing-horse-grayhounds',
          children: [
            {
              name: 'Horses',
              url: 'betting/racings/horse-racing',
              icon: '',
            },
            {
              name: 'Greyhounds',
              url: 'betting/racings/greyhounds',
              icon: '',
            },
          ],
        },
        {
          url: 'betting/prematch/all/multiples',
          type: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: true,
          icon: 'flash',
        },
        {
          url: 'betting/prematch/all/boosted/all/all',
          type: 'boostedOdds',
          name: 'Boosted Odds',
          enabled: true,
          icon: 'boosted-odd',
        },
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: true,
      nestedItems: [
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          type: 'goldenRace',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          type: 'pascalGaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
      ],
    },
    {
      url: 'betting/results',
      name: 'Results',
      enabled: true,
    },
    {
      url: 'tickets',
      name: 'Tickets',
      enabled: true,
    },
  ],
  defaultTerminalParams: { pid: 18774663, tid: 41805, token: 'dhTgLw==', currency: 'HTG' },
  sportsbook: {
    enableBoostedOdds: true,
  },
};
